import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarTaxaLayer from "../components/CadastrarTaxaLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarTaxaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("taxa.breadcrumb.create")} />
      <CadastrarTaxaLayer />
    </MasterLayout>
  );
};

export default CadastrarTaxaPage;
